module.exports = __webpack_public_path__ + "img/img2.baa53857.jpg";